import { ObjectIdSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const updateInvoiceAdditionalDetailsResponseSchema = oz.object({ 
  invoiceId: ObjectIdSchema, 
}).openapi('UpdateInvoiceAdditionalDetailsResponse');

export type UpdateInvoiceAdditionalDetailsResponse = oz.infer<typeof updateInvoiceAdditionalDetailsResponseSchema>;